/**
 * @file
 * A JavaScript file containing scroll to text functionality
 *
 */

(function (Drupal, $) {
  Drupal.behaviors.scrollToText = {
    attach: function (context) {
      'use strict';

      $('a[scroll-to-text]', context)
        .once('scroll-to-text')
        .addClass("scroll-to-text")
        .each(function () {
          $(this).on('click',function(){
            var text = $(this).attr("scroll-to-text");
            var elem = $("*:contains("+text+"):last");
            var closest = $(this).attr("scroll-to-wrapper-class-contains");
            var offset = 0;
            if(typeof closest !== 'undefined'){
              elem = $(elem).closest("div[class*="+closest+"]"); 
            }
            offset = $(elem).offset().top;
            $("html, body").animate({ scrollTop: offset-100 }, 300);      
          });
      });      

    }
  }
})(Drupal, jQuery);
